export default function useHex(baseHex: string, opacity: number): string {
  if (typeof baseHex !== 'string')
    throw new TypeError('baseHex must be a string');
  if (typeof opacity !== 'number' || !isFinite(opacity))
    throw new TypeError('opacity must be a finite number');

  // normalize opacity
  let o = opacity;
  if (o > 1 && o <= 100) {
    o = o / 100;
  }
  o = Math.max(0, Math.min(1, o));

  let hex = baseHex.replace(/^#/, '').trim();
  if (hex.length === 3)
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  if (hex.length !== 6 || !/^[0-9a-fA-F]{6}$/.test(hex))
    throw new Error('baseHex must be a valid 3- or 6-digit hex color');

  const alphaByte = Math.round(o * 255);
  const alphaHex = alphaByte.toString(16).padStart(2, '0');

  return `#${hex.toLowerCase()}${alphaHex}`;
}
